var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointOnly12X12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#point_only_12x12_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 12.001a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
  fill: "#2D91FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.036 3.262c0-.216.175-.391.391-.391h1.989a2.14 2.14 0 0 1 1.55.62c.42.414.63.921.63 1.523 0 .603-.21 1.11-.63 1.523-.426.414-.943.62-1.55.62H5.294v1.407a.63.63 0 0 1-1.258 0V3.262Zm1.258 2.719h1.122c.267 0 .49-.093.665-.279a.963.963 0 0 0 .264-.689.966.966 0 0 0-.264-.692.887.887 0 0 0-.665-.274H5.294V5.98Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "point_only_12x12_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export default SvgPointOnly12X12;